import React, { memo } from "react";
import Image from "react-bootstrap/Image";
import { styled } from "@mui/material/styles";
import CircularProgress from "@mui/material/CircularProgress";
import { DEFAULT_OLERN_LOGO } from "../models/Constants";

const SplashScreenContainer = styled("div")(({ theme }) => ({
	display: "flex",
	flexDirection: "column",
	justifyContent: "center",
	alignItems: "center",
	width: "100vw",
	height: "100vh",
	backgroundColor: "#ffffff",
}));

const SplashScreen = memo(() => {
	return (
		<SplashScreenContainer>
			<CircularProgress className="d-block" />
			<Image
				style={{
					objectFit: "contain",
					width: "150px",
					height: "auto",
				}}
				src={DEFAULT_OLERN_LOGO}
				alt="Olern Logo"
			/>
		</SplashScreenContainer>
	);
});

export default SplashScreen;
